import React from 'react'
import styles from './style.module.scss'
import { MagnifierIcon } from '../'

export const Search = ({type, placeholder, parent, childs}) => {
  const handleSearch = ({target}) => {
    if ( !parent || parent.length === 0 ) return

    const rows = parent.querySelectorAll(childs);
    if ( !rows || rows.length === 0 ) return

    [...rows].map(row => {
      row.style.transition = "all 150ms ease";
      if (row.innerHTML.toUpperCase().indexOf(target.value.toUpperCase()) === -1) {
        return row.style.display = "none"
      }
      row.style.display = "table-row"
    })
  }

  return (
    <form onSubmit={e => e.preventDefault()}>
      <div className={styles['search__wrapper']}>
        <input type={type} onChange={handleSearch} placeholder={placeholder} />
        <MagnifierIcon />
      </div>
    </form>
  )
}